import { IoLogoWhatsapp } from "react-icons/io5";
import { WHATSAPP_LINK } from "../../Utils/contact";

export default function WhatsAppFab() {
  return (
    <a
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
      title="Contact us on WhatsApp"
      aria-label="Contact us on WhatsApp"
    >
      <IoLogoWhatsapp className="w-6 h-6 sm:w-7 sm:h-7" />
    </a>
  );
}
